module.exports = __webpack_public_path__ + "static/media/upload-icon.155caec9.png";